export default {
    test: 'tes',
};
